import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgBlock = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "nonzero",
			d: "M8 .5C3.86.5.5 3.86.5 8c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5C15.5 3.86 12.14.5 8 .5zM2 8c0-3.315 2.685-6 6-6a5.93 5.93 0 0 1 3.675 1.268l-8.408 8.407A5.927 5.927 0 0 1 2 8zm6 6a5.927 5.927 0 0 1-3.675-1.268l8.407-8.407A5.927 5.927 0 0 1 14 8c0 3.315-2.685 6-6 6z"
		})
	})
});
export default SvgBlock;
